import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';
import Price from '@spotahome/ui-library/src/tenant/components/Homecard/common/Price';

import {
  usePricingContext,
  useDisplayListingPricing
} from '../context/PricingContext';

import RentableUnitPriceOffer from './RentableUnitPriceOffer';

import './RentableUnitPrice.scss';

const RentableUnitPrice = ({ showPrice = true, isSmallerRate = false }) => {
  const { priceRange, isMonthlyPrice, pricingDetails } = usePricingContext();
  const displayPricing = useDisplayListingPricing();
  const { price } = displayPricing;

  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  const perMonthClasses = classNames('rentable-unit-price__per-month', {
    'rentable-unit-price__per-month-smaller': isSmallerRate
  });

  if (!showPrice) {
    return (
      <span className="rentable-unit-price__hint">
        {trans('search.hide-prices-until-dates')}
      </span>
    );
  }

  if (isListingSimplificationHeaderVariant && !pricingDetails.pricing) {
    return (
      <>
        <Price
          className="rentable-unit-price__price"
          amount={priceRange?.seasonalPrice?.min ?? priceRange.amount}
          forcePrefix
          forceVariant
          biggerFont
        />
        <div>
          <span className="rentable-unit-price__hint">
            {trans('property_show.book_now_card.select_dates.exact_prices')}
          </span>
        </div>
      </>
    );
  }

  if (pricingDetails?.hasOffer) {
    return <RentableUnitPriceOffer {...displayPricing} />;
  }

  return isListingSimplificationHeaderVariant ? (
    <Price
      amount={priceRange?.seasonalPrice?.min ?? priceRange.amount}
      forceVariant
      biggerFont
      forcePrefix={!!priceRange?.seasonalPrice?.min}
    />
  ) : (
    <span className="rentable-unit-price">
      {!priceRange.isSeasonalPriceFeatureOn &&
        isMonthlyPrice &&
        `${trans('rentable_unit_price.label.from')} `}
      <span className="rentable-unit-price__number">{price}</span>
      <span className={perMonthClasses}>
        {' '}
        {trans('property_show.book_now_card.per_month')}
      </span>
    </span>
  );
};

RentableUnitPrice.propTypes = {
  showPrice: PropTypes.bool,
  isSmallerRate: PropTypes.bool
};

export default RentableUnitPrice;
